import React, { useRef, useState, useEffect, Fragment } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col, Table, Modal, Button, Spinner } from "react-bootstrap";
//import ExamineeEdit from "./ExamineeEdit";
//import ExpandField from "../../shared/ExpandField";
import EditModal from "./EditModal";
//import ExamineeHakalaReasons from "./ExamineeHakalaReasons";
import AddModal from "./AddModal";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import HandleHttpErrors from "../../HandleHttpErrors";

const baseURL = process.env.REACT_APP_API_JOBS;

const ListExaminees = ({
  increment,
  counter,
  setCounter,
  exam,
  setExamineesNumber,
  showAdd,
  setShowAdd,
  activeMoamads,
}) => {
  const [examineeId, setExamineeId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const [examinees, setExaminees] = useState(null);
  const [evaluationInstitutes, setEvaluationInstitutes] = useState(null);
  const [examineeStatus, setExamineeStatus] = useState([]);
  const [hakalaReason, setHakalaReason] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [hakalaReasonOptions, SetHakalaReasonOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();
  //const handleShowModal = () => setShow(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "examineestatus/", {
          signal: controller.signal,
        });
        isMounted && setExamineeStatus(response.data[0].examineeStatus);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "examinee?assessment_id=" + exam.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setExaminees(response.data);
          setExamineesNumber(response.data.length);
        }
      } catch (err) {
        if (err.response) {
          alert(
            "קביעת מבחן חדש, המשך...",
            HandleHttpErrors(err.response.status)
          );
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    const getData2 = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "evaluationinstitute",
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setEvaluationInstitutes(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert("wwwww", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData2();
    const getData3 = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "hakalareason", {
          signal: controller.signal,
        });
        if (isMounted) {
          setHakalaReason(response.data);
          const hakalaOptions = response.data.map((item) => ({
            value: item.id,
            label: item.title,
          }));
          SetHakalaReasonOptions(hakalaOptions);
        }
      } catch (err) {
        if (err.response) {
          alert("wwwww", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData3();
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);
  const handleEditClick = (event, examinees) => {
    event.preventDefault();
    setShowEdit(true);
    setExamineeId(examinees.id);
  };
  const handleCancelClick = () => {
    setExamineeId(null);
  };
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    if (!examinees) return null;
    return (
      <>
        <div className="mx-auto">
          <AddModal
            showAdd={showAdd}
            setShowAdd={setShowAdd}
            increment={increment}
            examineeStatus={examineeStatus}
            setExamineeId={setExamineeId}
            exam={exam}
            activeMoamads={activeMoamads}
            optionList={hakalaReasonOptions}
          />
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>שם</th>
                      <th>ת"ז</th>
                      <th>מצב המבחן</th>
                      <th>תאריך</th>
                      <th>מועד</th>
                      <th>הקלת שפה</th>
                      <th>הקלת זמן</th>
                      <th>סיבת ההקלה</th>
                      <th>הערות</th>
                      <th>פועלות</th>
                    </tr>
                  </thead>
                  <tbody>
                    {examinees
                      ?.slice()
                      .sort((a, b) => {
                        if (a.full_name !== b.full_name) {
                          // Sort by title first
                          return a.full_name.localeCompare(b.full_name);
                        } else {
                          // If titles are the same, sort by id
                          return b.id - a.id;
                        }
                      })
                      .map((examinee) => (
                        <Fragment key={examinee.id}>
                          {examineeId === examinee.id ? (
                            <EditModal
                              showEdit={showEdit}
                              setShowEdit={setShowEdit}
                              examinee={examinee}
                              increment={increment}
                              examineeStatus={examineeStatus}
                              setExamineeId={setExamineeId}
                              optionList={hakalaReasonOptions}
                            />
                          ) : (
                            <ReadOnlyRows
                              examinee={examinee}
                              handleEditClick={handleEditClick}
                              increment={increment}
                              setExamineeId={setExamineeId}
                              setShowError={setShowError}
                              setErrorMessage={setErrorMessage}
                              setErrorHeader={setErrorHeader}
                            />
                          )}
                        </Fragment>
                      ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>

        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default ListExaminees;

const ReadOnlyRows = ({
  examinee,
  handleEditClick,
  setExamineeId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [showExpand, setShowExpand] = useState(false);
  const [expandReasons, setExpandReasons] = useState(false);
  const tdRef = useRef(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת נבחן בעל מזהה "${id}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();

    let isMounted = true;
    const controller = new AbortController();
    const deletePost = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "examinee/" + examinee.id,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    deletePost();
    setExamineeId(null);
  };

  /*
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  */
  const closeExpandReasons = () => {
    setExpandReasons(false);
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={examinee.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{examinee.id}</td>
        <td>{examinee.full_name}</td>
        <td>{examinee.idz}</td>
        <td>{examinee.examinee_status}</td>
        <td>{examinee.date}</td>
        <td>{examinee.time.toString().substr(0, 5)}</td>
        <td>{examinee.hakala_lang ? "כן" : "לא"}</td>
        <td>{examinee.hakala_time ? "כן" : "לא"}</td>
        <td
          style={{ color: "brown", cursor: "pointer" }}
          onClick={() => {
            setExpandReasons(true);
          }}
        >
          {examinee?.hrfe_examinee?.length > 0 ? "הצג" : ""}
        </td>
        <td
          style={{ color: "brown", cursor: "pointer" }}
          onClick={() => {
            setShowExpand(true);
          }}
        >
          {examinee?.notes?.length > 0 ? "הרחב" : ""}
        </td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, examinee)}
          >
            <FiEdit2 />
          </button>
          <span> </span>
          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("examinee", examinee.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
      <Modal
        show={expandReasons}
        onHide={() => {
          setExpandReasons(false);
        }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {"סידורי: " +
              examinee.id +
              "-" +
              " סיבות ההקלה לנבחן " +
              examinee.full_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {examinee?.hrfe_examinee?.map((item) => (
              <li key={item.id}>{item.hakalareason + " :" + item.title}</li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
      <Modal
        show={showExpand}
        onHide={() => setShowExpand(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {"סידורי: " +
              examinee.id +
              "-" +
              "  הרחבת הערות לנבחן " +
              examinee.full_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{examinee.notes}</Modal.Body>
      </Modal>
    </>
  );
};
